module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/exportDataHoverUB.54f4a42a.svg";